import request from '../utils/request';



export function getIngredients(params) {
  return request({
    url: '/api/settings/components/',
    method: 'get',
    params
  })
}

export function getObjectCompanies(params) {
  return request({
    url: '/api/company-objects/objects/',
    method: 'get',
    params
  })
}
